module.exports = __webpack_public_path__ + "static/media/hall-P9-2026.b8c7cb41.svg";